import moment from "moment";
import pluralize, { singular } from "pluralize";
import MilkBottle from './../assets/img/mm/allergens/milk.svg';
import Eggitem from './../assets/img/mm/allergens/egg.svg';
import Fishitem from './../assets/img/mm/allergens/fish.svg';
import Wheat from './../assets/img/mm/allergens/wheat.svg';
import peanut from './../assets/img/mm/allergens/peanut.svg';
import Treenuts from './../assets/img/mm/allergens/treenuts.svg';
import soy from './../assets/img/mm/allergens/soy.svg';
import Shellfish from './../assets/img/mm/allergens/shellfish.svg';
import Sesame from './../assets/img/mm/allergens/sesame.svg';
import Gluten from './../assets/img/mm/allergens/gluten.svg';
import Crab from './../assets/img/mm/allergens/crab.svg';
import Lactose from './../assets/img/mm/allergens/lactose.svg';
import Nuts from './../assets/img/mm/allergens/nuts.svg';
import Celery from './../assets/img/mm/allergens/celery.svg';
import Mustard from './../assets/img/mm/allergens/mustard.svg';
import Snail from './../assets/img/mm/allergens/snails.svg';
import Lupins from './../assets/img/mm/allergens/lupins.svg';
import Dioxido from './../assets/img/mm/allergens/dioxido.svg';


import DietDefault from './../assets/img/mm/special-diet/diet.svg';

import LunchIcon from './../assets/img/mm/others/lunch.svg';
import BreakfastIcon from './../assets/img/mm/others/breakfast.svg';
import SnackIcon from './../assets/img/mm/others/snack.svg';
import DinnerIcon from './../assets/img/mm/others/dinner.svg';
import _ from 'lodash';
import { text } from "@fortawesome/fontawesome-svg-core";

export const STORE_TYPE = {
  'SS': 'SESSION',
  'LS': 'LOCAL'
}
export const REQUEST_STATUS_CONST = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
}

export const MANAGE_STORE = STORE_TYPE.LS;

export const isIterableArray = (array) =>
  Array.isArray(array) && !!array.length;

//===============================
// Breakpoints
//===============================
export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1540,
};

//===============================
// Local Store
//===============================
export const getItemFromStore = (key, defaultValue, store = localStorage) =>
  JSON.parse(store.getItem(key)) || defaultValue;
export const setItemToStore = (key, payload, store = localStorage) =>
  store.setItem(key, JSON.stringify(payload));
export const getStoreSpace = (store = localStorage) =>
  parseFloat(
    (
      escape(encodeURIComponent(JSON.stringify(store))).length /
      (1024 * 1024)
    ).toFixed(2)
  );

//===============================
// Session Store
//===============================
export const getItemFromSessionStore = (
  key,
  defaultValue,
  store = sessionStorage
) => JSON.parse(store.getItem(key)) || defaultValue;
export const setItemToSessionStore = (key, payload, store = sessionStorage) =>
  store.setItem(key, JSON.stringify(payload));
export const getStoreSessionSpace = (store = sessionStorage) =>
  parseFloat(
    (
      escape(encodeURIComponent(JSON.stringify(store))).length /
      (1024 * 1024)
    ).toFixed(2)
  );

//===============================
// Cookie
//===============================
export const getCookieValue = (name) => {
  const value = document.cookie.match(
    "(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)"
  );
  return value ? value.pop() : null;
};

export const createCookie = (name, value, cookieExpireTime) => {
  const date = new Date();
  date.setTime(date.getTime() + cookieExpireTime);
  const expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + value + expires + "; path=/";
};

//===============================
// Moment
//===============================
export const getDuration = (startDate, endDate) => {
  if (!moment.isMoment(startDate))
    throw new Error(
      `Start date must be a moment object, received ${typeof startDate}`
    );
  if (endDate && !moment.isMoment(endDate))
    throw new Error(
      `End date must be a moment object, received ${typeof startDate}`
    );

  return `${startDate.format("ll")} - ${endDate ? endDate.format("ll") : "Present"
    } • ${startDate.from(endDate || moment(), true)}`;
};
//convert yearMonth to monthYear
export const convertToMonthYear = (yearMonth) => {
  if (yearMonth) {
    const year = yearMonth.substr(0, 4);
    const month = yearMonth.substr(4, 2);
    const monthYear = moment(yearMonth, "YYYYMM").format("MMM YYYY");
    return monthYear;
  }

  return "";
};
export const numberFormatter = (number, fixed = 2) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(number)) >= 1.0e9
    ? (Math.abs(Number(number)) / 1.0e9).toFixed(fixed) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(number)) >= 1.0e6
      ? (Math.abs(Number(number)) / 1.0e6).toFixed(fixed) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(number)) >= 1.0e3
        ? (Math.abs(Number(number)) / 1.0e3).toFixed(fixed) + "K"
        : Math.abs(Number(number)).toFixed(fixed);
};

//===============================
// Colors
//===============================
export const hexToRgb = (hexValue) => {
  let hex;
  hexValue.indexOf("#") === 0
    ? (hex = hexValue.substring(1))
    : (hex = hexValue);
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)
  );
  return result
    ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16),
    ]
    : null;
};

export const rgbColor = (color = colors[0]) => `rgb(${hexToRgb(color)})`;
export const rgbaColor = (color = colors[0], alpha = 0.5) =>
  `rgba(${hexToRgb(color)},${alpha})`;

export const colors = [
  "#2c7be5",
  "#00d97e",
  "#e63757",
  "#39afd1",
  "#fd7e14",
  "#02a8b5",
  "#727cf5",
  "#6b5eae",
  "#ff679b",
  "#f6c343",
];

export const themeColors = {
  primary: "#ea7066",
  secondary: "#748194",
  success: "#b5d56a",
  info: "#84bed6",
  warning: "#f0c24b",
  danger: "#ea7066",
  light: "#f9fafd",
  dark: "#0b1727",
};

export const grays = {
  white: "#fff",
  100: "#f9fafd",
  200: "#edf2f9",
  300: "#d8e2ef",
  400: "#b6c1d2",
  500: "#9da9bb",
  600: "#748194",
  700: "#5e6e82",
  800: "#4d5969",
  900: "#344050",
  1000: "#232e3c",
  1100: "#0b1727",
  black: "#000",
};

export const darkGrays = {
  white: "#fff",
  1100: "#f9fafd",
  1000: "#edf2f9",
  900: "#d8e2ef",
  800: "#b6c1d2",
  700: "#9da9bb",
  600: "#748194",
  500: "#5e6e82",
  400: "#4d5969",
  300: "#344050",
  200: "#232e3c",
  100: "#0b1727",
  black: "#000",
};

export const getGrays = (isDark) => (isDark ? darkGrays : grays);

export const rgbColors = colors.map((color) => rgbColor(color));
export const rgbaColors = colors.map((color) => rgbaColor(color));

//===============================
// Echarts
//===============================
export const getColor = (name, dom = document.documentElement) => {
  return getComputedStyle(dom).getPropertyValue(`--falcon-${name}`).trim();
};

export const getPosition = (pos, params, dom, rect, size) => ({
  top: pos[1] - size.contentSize[1] - 10,
  left: pos[0] - size.contentSize[0] / 2,
});

//===============================
// E-Commerce
//===============================
export const calculateSale = (base, less = 0, fix = 2) =>
  (base - base * (less / 100)).toFixed(fix);
export const getTotalPrice = (cart, baseItems) =>
  cart.reduce((accumulator, currentValue) => {
    const { id, quantity } = currentValue;
    const { price, sale } = baseItems.find((item) => item.id === id);
    return accumulator + calculateSale(price, sale) * quantity;
  }, 0);

//===============================
// Helpers
//===============================
export const getPaginationArray = (totalSize, sizePerPage) => {
  const noOfPages = Math.ceil(totalSize / sizePerPage);
  const array = [];
  let pageNo = 1;
  while (pageNo <= noOfPages) {
    array.push(pageNo);
    pageNo = pageNo + 1;
  }
  return array;
};

export const capitalize = (str) =>
  (str.charAt(0).toUpperCase() + str.slice(1)).replace(/-/g, " ");

export const routesSlicer = ({ routes, columns = 3, rows }) => {
  const routesCollection = [];
  (routes || []).map((route) => {
    if (route.children) {
      return route.children.map((item) => {
        if (item.children) {
          return routesCollection.push(...item.children);
        }
        return routesCollection.push(item);
      });
    }
    return routesCollection.push(route);
  });

  const totalRoutes = routesCollection.length;
  const calculatedRows = rows || Math.ceil(totalRoutes / columns);
  const routesChunks = [];
  for (let i = 0; i < totalRoutes; i += calculatedRows) {
    routesChunks.push(routesCollection.slice(i, i + calculatedRows));
  }
  return routesChunks;
};

export const getPageName = (pageName) => {
  return window.location.pathname.split("/").slice(-1)[0] === pageName;
};

export const copyToClipBoard = (textFieldRef) => {
  const textField = textFieldRef.current;
  textField.focus();
  textField.select();
  document.execCommand("copy");
};

export const menuTypeItems = {
  BREAKFAST: { text: "Breakfast", image: BreakfastIcon, order: 1 },
  LUNCH: { text: "Lunch", image: LunchIcon, order: 2 },
  SNACK: { text: "Snack", image: SnackIcon, order: 3 },
  DINNER: { text: "Dinner", image: DinnerIcon, order: 4 },
};
export const additionalMenuTypeItems = {
  SIDE: { text: "Side" },
  EXTRA: { text: "A La Carte" },
};
export const additionalMenuType_MainCourse = {
  ENTREE: { text: "Entree", sortOrder: 0 },
  SIDE: { text: "Side", sortOrder: 1 },
  EXTRA: { text: "A La Carte", sortOrder: 2 }
};
export const ANALYSIS_MENU_TYPE = {
  ENTREE: { text: "Entree", sortOrder: 0 },
  /* GRAINS: {
    text: "Grains", sortOrder: 1, subTypesArray: [
      {
        "label": "WGR",
        "value": "WGR"
      },
      {
        "label": "non-WGR",
        "value": "non-WGR"
      },
      {
        "label": "grain-based dessert (WGR)",
        "value": "grain-based dessert (WGR)"
      },
      {
        "label": "grain-based dessert (non-WGR)",
        "value": "grain-based dessert (non-WGR)"
      }
    ]
  }, */
  FRUIT: {
    text: "Fruits", sortOrder: 2, subTypesArray: [
      {
        "label": "Whole Fruit",
        "value": "wholeFruit"
      },
      {
        "label": "Fruit Juice",
        "value": "fruitJuice"
      }
    ]
  },
  VEGETABLES: {
    text: "Vegetables", sortOrder: 3, subTypesArray: [{
      "label": "Dark Green",
      "value": "darkGreen"
    },
    {
      "label": "Red/Orange",
      "value": "redOrange"
    },
    {
      "label": "Beans, Peas & Lentils",
      "value": "beansPeas"
    },
    {
      "label": "Starchy",
      "value": "starchy"
    },
    {
      "label": "Other",
      "value": "other"
    },
    {
      'label': 'Additional Vegetable',
      'value': 'Additional Vegetable'
    },
    {
      'label': 'Vegetable Juice',
      'value': 'Vegetable Juice'
    }
    ]
  },
  SIDE: { text: "Side", sortOrder: 4 },
  EXTRA: { text: "A La Carte", sortOrder: 5 },
  MILK: {
    text: "Milk", sortOrder: 6, subTypesArray: [
      {
        "label": "Fat-free milk unflavored",
        "value": "Fat-free milk unflavored"
      },
      {
        "label": "Fat-free milk flavored",
        "value": "Fat-free milk flavored"
      },
      {
        "label": "Low-fat (1%) milk unflavored",
        "value": "Low-fat (1%) milk unflavored"
      },
      {
        "label": "Low-fat (1%) milk flavored",
        "value": "Low-fat (1%) milk flavored"
      },
      {
        "label": "Whole fat/2% milk unflavored",
        "value": "Whole fat/2% milk unflavored"
      },
      {
        "label": "Whole fat/2% milk flavored",
        "value": "Whole fat/2% milk flavored"
      }

    ]
  },
  MISCELLANEOUS: { text: "Miscellaneous", sortOrder: 7 }
};

export const VEGETABLES_MENU_TYPE = [
  { label: "Dark Green", value: "DARK_GREEN" },
  { label: "Red/Orange", value: "RED_OR_ORANGE" },
  { label: "Beans and Peas", value: "BEANS_AND_PEAS" },
  { label: "Starchy", value: "STARCHY" },
  { label: "Others", value: "OTHERS" },
];
export const allMenuTypes = [
  { value: "MEAL", text: "Lunch" },
  { value: "BREAKFAST", text: "Breakfast" },
  { value: "SNACK", text: "Snack" },
  /* {value:'DINNER',text:'Dinner'}, */
  { value: "EXTRA", text: "A La Carte" },
  { value: "SIDE", text: "Side" },
];
export const CalenderViewOptions = {
  DAY: "Day",
  WEEK: "Week",
  MONTH: "Month",
};
export const paymentType = {
  Online: "Online",
  Check: "Check",
  Cash: "Cash",
  CreditCard: "CreditCard",
};
export const updatedNutritions = {
  calories: { display: "Calories *", tabindex: 1, isRequired: true },
  protein: { display: "Protein (g) *", tabindex: 2, isRequired: true },
  cholestral: { display: "Cholesterol (mg) *", tabindex: 3, isRequired: true },
  saturatedFat: {
    display: "Saturated Fat (g) *",
    tabindex: 4,
    isRequired: true,
  },
  totalFat: { display: "Total Fat (g) *", tabindex: 5, isRequired: true },
  totalCarbohydrate: {
    display: "Total Carbohydrates (g) *",
    tabindex: 6,
    isRequired: true,
  },
  sugars: { display: "Added sugars (g) *", tabindex: 7, isRequired: true },
  sodium: { display: "Sodium (mg)", tabindex: 8 },
  dietaryFiber: { display: "Dietary fiber (g)", tabindex: 9 },
};
export const filterAllergensByCountry = (countryCode) => {
  if (countryCode == 'US') {
    const filterObject = {};
    Object.keys(allergens).map(key => {
      if ((allergens[key] || {}).showForUS) {
        filterObject[key] = allergens[key];
      }
    });
    return filterObject;
  } else {
    return allergens;
  }
}
export const allergens = {
  "Milk": { display: 'Milk', tabindex: 1, isRequired: false, image: MilkBottle, showForUS: true },
  "Wheat": { display: 'Wheat', tabindex: 2, isRequired: false, image: Wheat, showForUS: true },
  "Eggs": { display: 'Eggs', tabindex: 3, isRequired: false, image: Eggitem, showForUS: true },
  "Soy": { display: 'Soy', tabindex: 4, isRequired: false, image: soy, showForUS: true },
  "Fish": { display: 'Fish', tabindex: 5, isRequired: false, image: Fishitem, showForUS: true },
  "Shellfish": { display: 'Shellfish', tabindex: 6, isRequired: false, image: Shellfish, showForUS: true },
  "Peanuts": { display: 'Peanuts', tabindex: 7, isRequired: false, image: peanut, showForUS: true },
  "Sesame": { display: 'Sesame', tabindex: 8, isRequired: false, image: Sesame, showForUS: true },
  "Nuts": { display: 'Nuts', tabindex: 9, isRequired: false, image: Nuts, showForUS: true },
  "TreeNuts": { display: 'TreeNuts', tabindex: 10, isRequired: false, image: Treenuts },
  "Gluten": { display: 'Gluten', tabindex: 11, isRequired: false, image: Gluten },
  "Lactose": { display: 'Lactose', tabindex: 12, isRequired: false, image: Lactose },
  "Celery": { display: 'Celery', tabindex: 13, isRequired: false, image: Celery },
  "Mustard": { display: 'Mustard', tabindex: 14, isRequired: false, image: Mustard },
  "Lupins": { display: 'Lupins', tabindex: 15, isRequired: false, image: Lupins },
  "SnailsShellfish": { display: 'Snails & Shellfish', tabindex: 16, isRequired: false, image: Snail },
  "CrabCrustaceans": { display: 'Crab & Crustaceans', tabindex: 17, isRequired: false, image: Crab },
  "SulfurDioxideSulfates": { display: 'Sulfur Dioxide & Sulfates', tabindex: 18, isRequired: false, image: Dioxido },
  "Soja": { display: 'Soja', tabindex: 19, isRequired: false, image: soy }
}
export const specialDiteraryList = [
  {
    name: "GF",
    displayName: "GLUTEN FREE",
    value: "GlutenFree",
    image: DietDefault
  },
  {
    name: "DF",
    displayName: "DAIRY FREE",
    value: "DairyFree",
    image: DietDefault
  },
  {
    name: "V",
    displayName: "VEGAN",
    value: "Vegan",
    image: DietDefault
  },
  {
    name: "VG",
    displayName: "Vegetarian",
    value: "VEG",
    image: DietDefault
  },
  {
    name: "K",
    displayName: "KOSHER",
    value: "Kosher",
    image: DietDefault
  },
  {
    name: "O",
    displayName: "ORGANIC",
    value: "Organic",
    image: DietDefault
  },
  {
    name: "S",
    displayName: "Sugar Free",
    value: "SugarFree",
    image: DietDefault
  },
  {
    name: "NTF",
    displayName: "NO TRANS FAT",
    value: "NoTransFat",
    image: DietDefault
  },
  {
    name: "NM",
    displayName: "NO MSG",
    value: "NoMsg",
    image: DietDefault
  },
  {
    name: "CP",
    displayName: "Contains Pork",
    value: "ContainsPork",
    image: DietDefault
  },
];

export const nutritions = {
  calories: { display: "Calories *", tabindex: 1, isRequired: true },
  protein: { display: "Protein (g) *", tabindex: 2, isRequired: true },
  calcium: { display: "Calcium (mg) *", tabindex: 3, isRequired: true },
  potassium: { display: "Potassium (mg) *", tabindex: 4, isRequired: true },
  cholestral: { display: "Cholesterol (mg) *", tabindex: 5, isRequired: true },
  saturatedFat: {
    display: "Saturated Fat (g) *",
    tabindex: 6,
    isRequired: true,
  },
  totalFat: { display: "Total Fat (g) *", tabindex: 7, isRequired: true },
  totalCarbohydrate: {
    display: "Total Carbohydrates (g) *",
    tabindex: 8,
    isRequired: true,
  },
  iron: { display: "Iron (mg) *", tabindex: 9, isRequired: true },
  sugars: { display: "Added sugars (g) *", tabindex: 10, isRequired: true },
  phosphorous: { display: "Phosphorous (mg)", tabindex: 11 },
  sodium: { display: "Sodium (mg)", tabindex: 12 },
  dietaryFiber: { display: "Dietary fiber (g)", tabindex: 13 },
  vitaminA: { display: "Vitamin A (mcg)", tabindex: 14 },
  vitaminB6: { display: "Vitamin B6 (mg)", tabindex: 15 },
  vitaminB12: { display: "Vitamin B12 (mcg)", tabindex: 16 },
  vitaminC: { display: "Vitamin C (mg)", tabindex: 17 },
  vitaminD: { display: "Vitamin D (mcg)", tabindex: 18 },
  vitaminE: { display: "Vitamin E (mg)", tabindex: 19 },
  vitaminK: { display: "Vitamin K (mcg)", tabindex: 20 },
  pantothenicAcid: { display: "Pantothenic Acid (mg)", tabindex: 21 },
  folate: { display: "Folate (mcg)", tabindex: 22 },
  manganese: { display: "Manganese (mg)", tabindex: 23 },
  thiamin: { display: "Thiamin (mg)", tabindex: 24 },
  niacin: { display: "Niacin (mg)", tabindex: 25 },
  copper: { display: "Copper (mg)", tabindex: 26 },
  magnesium: { display: "Magnesium (mg)", tabindex: 27 },
  riboFlavin: { display: "Riboflavin (mg)", tabindex: 28 },
  selenium: { display: "Selenium (mcg)", tabindex: 29 },
  zinc: { display: "Zinc (mg)", tabindex: 30 },
};
export const enumDateFilterOptions = {
  Today: { text: "Today", value: "td" },
  Yesterday: { text: "Yesterday", value: "yd" },
  ThisWeek: { text: "This Week", value: "tw" },
  LastWeek: { text: "Last Week", value: "lw" },
  ThisMonth: { text: "This Month", value: "tm" },
  LastMonth: { text: "Last Month", value: "lm" },
  ThisYear: { text: "This Year", value: "ty" },
};

export const recipeAllergens = {
  304: { display: "Milk", tabindex: 1, isRequired: false, image: MilkBottle },
  306: {
    display: "Shellfish",
    tabindex: 2,
    isRequired: false,
    image: Shellfish,
  },
  303: { display: "Eggs", tabindex: 3, isRequired: false, image: Eggitem },
  305: { display: "Fish", tabindex: 4, isRequired: false, image: Fishitem },
  300: { display: "Wheat", tabindex: 5, isRequired: false, image: Wheat },
  302: { display: "Peanuts", tabindex: 6, isRequired: false, image: peanut },
  308: { display: "TreeNuts", tabindex: 7, isRequired: false, image: Treenuts },
  301: { display: "Soybeans", tabindex: 8, isRequired: false, image: soy },
  307: { display: "Sesame", tabindex: 9, isRequired: false, image: Sesame },
};

export const recipeSpecialDietaries = {
  400: {
    display: "Dairy Free",
    tabindex: 1,
    isRequired: false,
    image: MilkBottle,
  },
  401: { display: "Vegan", tabindex: 2, isRequired: false, image: Shellfish },
  402: {
    display: "Gluten Free",
    tabindex: 3,
    isRequired: false,
    image: Eggitem,
  },
  403: { display: "Kosher", tabindex: 4, isRequired: false, image: Fishitem },
  404: { display: "Organic", tabindex: 5, isRequired: false, image: Wheat },
  405: { display: "Sugar Free", tabindex: 6, isRequired: false, image: peanut },
  406: {
    display: "NO TRANS FAT",
    tabindex: 7,
    isRequired: false,
    image: Treenuts,
  },
  407: { display: "NO MSG", tabindex: 8, isRequired: false, image: soy },
  408: { display: "sesame", tabindex: 9, isRequired: false, image: Sesame },
  409: { display: "Vegetarian", tabindex: 10, isRequired: false, image: DietDefault },
};

export const frationData = [
  '1/8', '1/4', '1/3', '1/2', '2/3', '3/4', '3/8', '5/8'
];
export const servingSizeUnits = [
  'oz', 'gram', 'fl oz',
]
export const weightUnitsData = {
  'Pound': ['Ounce', 'Gram'],
  'Ounce': ['Gram'],
  'Gram': [],
  'Kilogram': ['Gram'],
  'Gallon': ['Quart', 'Pint', 'Cup', 'Tablespoon', 'Teaspoon'],
  'Quart': ['Pint', 'Cup', 'Tablespoon', 'Teaspoon'],
  'Pint': ['Cup', 'Tablespoon', 'Teaspoon'],
  'Cup': ['Tablespoon', 'Teaspoon'],
  'Tablespoon': ['Teaspoon'],
  'Teaspoon': [],
  'Liter': ['Milliliter'],
  'Milliliter': []
}
export const getWeightFull_ShortName = (type, input) => {
  const lowerCaseInput = (input || '').toLowerCase();
  const weightsObj = {
    tsp: 'Teaspoon',
    tbsp: 'Tablespoon',
    'fl oz': 'Fluid ounce',
    'c': 'Cup',
    'pt ': 'Pint',
    'qt': ' Quart',
    gal: 'Gallon',
    lb: 'Pound',
    oz: 'Ounce',
    g: 'Gram',
    kg: 'Kilogram',
    ml: 'Milliliter',
    l: 'Liter'
  }
  if (type == 'VALUE') {
    return weightsObj[lowerCaseInput] || '';
  } else if (type == 'KEY') {
    return Object.keys(weightsObj).find(key => weightsObj[key] === lowerCaseInput);
  } else {
    return ''
  }
}

export const getWeightFull_ShortName_New = (type, input) => {
  const lowerCaseInput = (input || '').toLowerCase();
  const weightsObj = {
    'teaspoon': 'tsp',
    'tablespoon': 'tbsp',
    'fl oz': 'Fluid ounce',
    'cup': 'c',
    'pint': 'pt ',
    'quart': 'qt',
    'gallon': 'gal',
    'pound': 'lb',
    'ounce': 'oz',
    'gram': 'g',
    'kilogram': 'kg',
    'milliliter': 'ml',
    l: 'Liter'
  }
  if (type == 'VALUE') {
    return weightsObj[lowerCaseInput] || '';
  } else if (type == 'KEY') {
    return Object.keys(weightsObj).find(key => weightsObj[key] === lowerCaseInput);
  } else {
    return ''
  }
}

export const weightsUnits = [
  { text: 'Teaspoon', unit: 'tsp', type: 'measure' },
  { text: 'Tablespoon', unit: 'tbsp', type: 'measure' },
  /*  { text: 'Fluid ounce', unit: 'fl oz', type: 'measure' }, */
  { text: 'Cup', unit: 'Cup', type: 'measure' },
  { text: 'Pint', unit: 'pt', type: 'measure' },
  { text: 'Quart', unit: 'qt', type: 'measure' },
  { text: 'Gallon', unit: 'gal', type: 'measure' },
  { text: 'Pound', unit: 'lb', type: 'weights' },
  { text: 'Ounce', unit: 'oz', type: 'weights' },
  { text: 'Gram', unit: 'g', type: 'weights' },
  { text: 'Kilogram', unit: 'kg', type: 'weights' },
  { text: 'Milliliter', unit: 'ml', type: 'metricWt' },
  /*  { text: 'Liter', unit: 'l', type: 'measure' }, */
  { text: 'Each', unit: 'each', type: 'measure' }
];

export const nutritionGroupPan = {
  G1: [208],
  G2: [204, 601, 307, 205, 203],
  G3: [328, 301, 303, 306, 208, 318, 320, 401, 207, 255]
}

export const groupBy = (list = [], props) => {
  return list.reduce((a, b) => {
    (a[b[props]] = a[b[props]] || []).push(b);
    return a;
  }, {});
};
export const numberParce = (value) => {
  try {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  } catch (ex) {
    return 0;
  }
};
export const computeInventoryTotalCost = (unitCost, quantity, additionalQty, itemsPerCase) => {
  const cost = numberParce(unitCost);
  const qty = numberParce(quantity);
  const addQty = numberParce(additionalQty);
  const ipc = numberParce(itemsPerCase) || 1;
  return numberParce(parseFloat(cost * (qty + addQty / ipc)).toFixed(2));
};
export const showFile = (blob, fileName) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], { type: "application/pdf" });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.

  var anchor = document.createElement("a");
  anchor.href = window.URL.createObjectURL(newBlob);

  anchor.name = fileName + ".pdf";
  anchor.dataset.downloadurl = [
    "application/pdf",
    anchor.download,
    anchor.href,
  ].join(":");

  if (typeof InstallTrigger !== "undefined") {
    window.open(anchor.href, "_blank");
    return;
  }
  anchor.target = "_blank";
  anchor.click();

  //var link = document.createElement('a');
  // link.href = data;
  // link.target='_blank';
  // link.setAttribute('open', fileName+".pdf");
  // link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    //  window.URL.revokeObjectURL(anchor.href);
  }, 100);
};

export const getPageSizeForPrintByCountry = (countryCode) => {
  let pageSize = {};
  const pageSizeObj = {
    US: { w: "8.5in", h: "11in" },
    ES: { w: "8.27in", h: "11.69in" },
    IN: { w: "8.27in", h: "11.69in" },
    GB: { w: "8.27in", h: "11.69in" },
    ZA: { w: "8.27in", h: "11.69in" },
    KR: { w: "8.27in", h: "11.69in" },
    EG: { w: "8.27in", h: "11.69in" },
    "": { w: "8.5in", h: "11in" },
  };
  pageSize = pageSizeObj[countryCode] || { w: "8.5in", h: "11in" };

  return pageSize;
};

export const getItemPriceTypes = () => {
  const currentUser = MANAGE_STORE == STORE_TYPE.LS ? getItemFromStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  }) : getItemFromSessionStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  });
  const { priceTypes } = currentUser.otherInfo;
  return priceTypes || [];
};

export const getSchoolID = (schoolName) => {
  const currentUser = MANAGE_STORE == STORE_TYPE.LS ? getItemFromStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  }) : getItemFromSessionStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  });
  const { schools } = currentUser.otherInfo;
  const schoolData =
    schools.find((item) => item.schoolName === schoolName) || {};
  return schoolData?.schoolId;
};
export const getSchoolData = (schoolName) => {
  const currentUser = MANAGE_STORE == STORE_TYPE.LS ? getItemFromStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  }) : getItemFromSessionStore("currentUser", {
    authInfo: {},
    otherInfo: {},
  });
  const { schools } = currentUser.otherInfo;
  const schoolData =
    schools.find((item) => item.schoolName === schoolName) || {};
  return schoolData || {};
};
export const renderCreditInfo = (data, creditingData) => {
  if (!data && !creditingData) return null;
  const x = data?.map((item) => {
    const name = creditingData?.[item.id]?.['name']
    return `${name} - ${item.measureValue}${item.measureType}`;
  });
  return <>{x?.length > 0 ? `(${x?.join(",")})` : null}</>;
};

export const getBase64 = file => {
  return new Promise(resolve => {
    let baseURL = "";
    // Make new FileReader
    let reader = new FileReader();
    // Convert the file to base64 text
    reader.readAsDataURL(file);
    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};


export const remvoeSpecialCharacters = (value = '') => {
  return value.replace(/[^a-zA-Z0-9 ]/, '').replace("'", "").replace("#", "").replace(";", "").replace(":", "");
}
export const deepCopy = (obj) => {
  if (typeof obj !== "object") {
    return obj;
  }
  return _.cloneDeep(obj);
}
export const getIdOfRecord = (selectedRow) => {
  const id = selectedRow._links.self.href.split('/').pop();
  return id
}



export const getNutritionDailyValue = ({ servingSize, nutValue, nutCode }) => {
  const NutritonReferralValues = {
    208: 2000,
    204: 78,
    605: 0,
    606: 20,
    601: 300,
    307: 2300,
    205: 275,
    269: undefined,
    291: 28,
    203: 50,
    328: 20,
    301: 1300,
    303: 18,
    306: 4700,
    539: 50,
    318: 900,
    320: 900,
    401: 90,
    207: 0,
    255: 0
  };
  try {
    if (servingSize == 0) {
      return 0;
    } else {
      const oneUnitNutVal = (1 / servingSize) * nutValue;
      if (NutritonReferralValues[nutCode]) {
        const nutRefVal = NutritonReferralValues[nutCode];
        const resVal = ((oneUnitNutVal / nutRefVal) * 100)
        return isNaN(resVal) ? undefined : resVal.toFixed(1);
      } else {
        return undefined;
      }
    }
  } catch (ex) {
    return undefined;
  }
}

export const parseNumber = (val) => {
  try {
    return isNaN(Number(val)) ? 0 : Number(val);
  } catch (ex) {
    return 0;
  }
}

export const isDecimalNo = (_number) => {
  try {
    let number = Number(_number);
    if (Number.isInteger(number)) {
      return false
    } else {
      return true;
    }
  } catch (ex) {
    return undefined;
  }
}
export const gcd = (a, b) => {
  return (b) ? gcd(b, a % b) : a;
}
export const decimalToFraction = (_number) => {
  if (isDecimalNo(_number) == false || isDecimalNo(_number) == undefined) {
    return {
      wholeNo: _number,
      fractionNo: ''
    }
  } else {
    const wholeNo = parseInt(_number);
    const _decimal = Number(_number) - wholeNo;

    let top = _decimal.toString().includes(".") ? _decimal.toString().replace(/\d+[.]/, '') : 0;
    let bottom = Math.pow(10, top.toString().replace('-', '').length);
    if (_decimal >= 1) {
      top = +top + (Math.floor(_decimal) * bottom);
    }
    else if (_decimal <= -1) {
      top = +top + (Math.ceil(_decimal) * bottom);
    }

    let x = Math.abs(gcd(top, bottom));
    return {
      //top: (top / x),
      //bottom: (bottom / x),
      //display: (top / x) + '/' + (bottom / x)
      wholeNo: wholeNo,
      fractionNo: (top / x) + '/' + (bottom / x)
    };
  }

};
export function getWeeksInMonth(year, month) {
  const weeks = [],
    firstDate = new Date(year, month, 1),
    lastDate = new Date(year, month + 1, 0),
    numDays = lastDate.getDate();

  let dayOfWeekCounter = firstDate.getDay();

  for (let date = 1; date <= numDays; date++) {
    if (dayOfWeekCounter === 0 || weeks.length === 0) {
      weeks.push([]);
    }
    weeks[weeks.length - 1].push(`${date}-${parseInt(month) + 1}`);
    dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
  }

  return weeks
    .filter((w) => !!w.length)
    .map((w, index) => ({
      start: w[0],
      end: w[w.length - 1],
      dates: w,
      week: `WEEK_${index + 1}`
    }));
}

export const bgColors = {
  'R': '#ea7066a3',
  'G': '#83d897',
  'Y': '#f0c24b'
};

export const calculateNgmsValue = (reqGmsVal, totAmgNut, servingSize, nutrientCode) => {
  let res = 0;
  try {
    if (servingSize == 0) {
      res = 0;
    } else {
      // For percentage nutrients (% saturated fat and % added sugar), don't scale
      if (nutrientCode === '700' || nutrientCode === '701' || nutrientCode === 700 || nutrientCode === 701) {
        res = totAmgNut; // Return the percentage value as-is
      } else {
        res = (totAmgNut / servingSize) * reqGmsVal;
      }
    }
  } catch (ex) {
  }
  return res;
}
export const LiquidFoodDensitys = {
  "Whole Milk": 1.03,
  "Skim Milk": 1.035,
  "Orange Juice": 1.038,
  "Grape Juice": 1.054,
  "Soy Drink": 1.07,
  "Water": 0.998,
  "Honey": 1.42
};

export const calculateWeightLiquidFoodUsingDensity = (gallons, density) => {
  //const density = 1.03; // g/mL
  const gallonToML = 3785.41; // 1 gallon in mL
  const volumeInML = gallons * gallonToML;
  return Number((volumeInML * density).toFixed(2)); // weight in grams
};
export const pluralizeWord = (word, count) => {
  pluralize.addIrregularRule('each', 'each');

  return pluralize(word, count);
}

export const encodeSpecialCharactersorImageUrl = (url) => {
  const urlArray = url.split('/');
  if (urlArray.length > 0) {
    const lastSegment = urlArray[urlArray.length - 1];
    urlArray[urlArray.length - 1] = encodeURIComponent(lastSegment);
  }
  const imageUrl = urlArray.join('/');
  return imageUrl;
}
